import React from "react";
import { IconKeyboardArrowRightBlue, IconMoreHorizBlue } from "assets/svg";

interface QuestPaginationProps {
  page: number;
  totalPages: number;
  paginationItems: (number | "...")[];
  onPageChange: (page: number) => void;
}

const QuestPagination = ({
  page,
  totalPages,
  paginationItems,
  onPageChange,
}: QuestPaginationProps) => {
  if (paginationItems.length === 0) return null;

  return (
    <div className="mt-[30px] flex items-center justify-center gap-[15px] text-[14px] font-bold text-[#1b4b86]">
      <button
        className="flex h-[30px] w-[30px] items-center justify-center rounded-full disabled:opacity-40"
        disabled={page === 1}
        onClick={() => onPageChange(Math.max(1, page - 1))}
        type="button"
      >
        <IconKeyboardArrowRightBlue className="h-5 w-5 rotate-180" />
      </button>

      <div className="flex items-center gap-[5px]">
        {paginationItems.map((item, index) =>
          item === "..." ? (
            <span
              key={`ellipsis-${index}`}
              className="flex h-[30px] w-[30px] items-center justify-center"
            >
              <IconMoreHorizBlue className="h-5 w-5" />
            </span>
          ) : (
            <button
              key={item}
              className={`flex h-[30px] min-w-[30px] items-center justify-center rounded-full px-[6px] ${
                page === item
                  ? "bg-[#1b4b86] text-white"
                  : "bg-white text-[#1b4b86]"
              }`}
              onClick={() => onPageChange(item)}
              type="button"
            >
              {item}
            </button>
          ),
        )}
      </div>

      <button
        className="flex h-[30px] w-[30px] items-center justify-center rounded-full disabled:opacity-40"
        disabled={page === totalPages}
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        type="button"
      >
        <IconKeyboardArrowRightBlue className="h-5 w-5" />
      </button>
    </div>
  );
};

export default QuestPagination;
